(function () {
    'use strict';

    var GROUP_FILTER_FACTORY = 'GroupFilterFactory';
    var EVENT_LOADING = 'EventLoading';
    var EVENT_PAGE_CHANGE = 'EventPageReset';

    angular
        .module('sodCommon')
        .factory(GROUP_FILTER_FACTORY, GroupFilterFactory);

    function GroupFilterFactory($q, $location, $rootScope, lodash, GenericModel, FilterFactory) {
        var configSet = {};
        var paramsSet = {};
        var defaultParams = {
            page: 1,
            pageSize: 15,
            skip: 0,
            take: 15,
        };

        var currentId = null;

        function applyFilter(id, params) {
            currentId = id;
            params = params || {};
            params = getParams(params);
            var deferApplyFilter = $q.defer();


            var method = getMethod();
            var datasource = getFullyFormedDatasource(method);

            if (method === 'search') {
                params = { data: params };
            }

            var model = new GenericModel(datasource);
            emitLoadingEvent(true);
            model[method](params).$promise.then(function (res) {
                emitLoadingEvent(false);
                deferApplyFilter.resolve(res);
                setCount(lodash.get(res, 'count', 0));
                emitChangeEvent(res);
            }, function (res) {
                setCount();
                emitChangeEvent();
                emitLoadingEvent(false);
                console.error('res', res);
            });
        }

        function setCount(count) {
            count = count || 0;
            lodash.set(configSet, [currentId, 'count'].join('.'), count);
        }

        function getCount() {
            return lodash.get(configSet, [currentId, 'count'].join('.'), 0);
        }

        function getMethod() {
            var condition = [
                !lodash.isEmpty(paramsSet[currentId].filter.search),
                !lodash.isEmpty(paramsSet[currentId].filter.applied),
            ];

            if (lodash.isEmpty(lodash.compact(condition))) {
                return 'query';
            } else {
                return 'search';
            }
        }

        function getFullyFormedDatasource(method) {
            var urlPath = [currentId, 'datasource', 'list', 'url'].join('.');
            switch (method) {
                case 'search':
                    return [lodash.get(configSet, urlPath, ''), 'filter'].join('/');
                case 'query':
                default:
                    return lodash.get(configSet, urlPath, '');
            }
        }

        function getParams(params) {
            var initialFilterParams = Object.assign({}, lodash.get(paramsSet, [currentId, 'filter'].join('.'), {}));
            var searchFilterConfig = lodash.get(configSet, [currentId, 'search_filter'].join('.'), {});

            paramsSet[currentId].filter.applied = lodash.reduce(FilterFactory.get(currentId), function(accum, value, key) {
                if (lodash.isEmpty(value)) return accum;
                if (key === lodash.get(searchFilterConfig, 'type')) {
                    return accum;
                }
                return lodash.concat(accum, { field: key, operator: 'in', value: value });
            }, []);

            var searchValue = lodash.get(FilterFactory.get(currentId), lodash.get(searchFilterConfig, 'type'), []);
            if (!lodash.isEmpty(searchValue)) {
                paramsSet[currentId].filter.search = [{
                    field: lodash.get(searchFilterConfig, 'type'),
                    operator: lodash.get(searchFilterConfig, 'operator'),
                    value: lodash.get(searchValue, 0),
                }];
            } else {
                paramsSet[currentId].filter.search = [];
            }
            if (!lodash.isEqual(initialFilterParams, lodash.get(paramsSet, [currentId, 'filter'].join('.'), {}))) {
                params.page = 1;
                emitPageChangeEvent(params.page);
            }

            var filteredParams = Object.assign({}, paramsSet[currentId], params);

            return Object.assign({}, filteredParams, {
                skip: (filteredParams.page - 1) * filteredParams.pageSize,
            });
        }

        function setSort(id, sortToSet) {
            currentId = id;
            paramsSet[currentId].sort = sortToSet;
            applyFilter(id);
        }

        function emitChangeEvent(data) {
            $rootScope.$broadcast([GROUP_FILTER_FACTORY, currentId].join('.'), data);
        }

        function emitLoadingEvent(isLoading) {
            $rootScope.$broadcast([GROUP_FILTER_FACTORY, currentId, EVENT_LOADING].join('.'), isLoading);
        }

        function emitPageChangeEvent(page) {
            $rootScope.$broadcast([GROUP_FILTER_FACTORY, currentId, EVENT_PAGE_CHANGE].join('.'), page);
        }

        return function(config) {
            var currentId = lodash.get(config, 'id', 'notExist');
            var isObjectConfig = typeof config === typeof {};

            if (!lodash.has(configSet, currentId) && isObjectConfig) {
                var configSetObject = {};
                configSetObject[currentId] = config;
                configSetObject[currentId] = Object.assign({}, configSetObject[currentId], {
                    debouncedApplyFilter: lodash.debounce(function(id, params) { applyFilter(id, params); }, 300),
                });
                configSet = Object.assign({}, configSet, configSetObject);
            }

            if (!lodash.has(paramsSet, currentId) && isObjectConfig) {
                var paramsSetObject = {};
                paramsSetObject[currentId] = Object.assign({}, defaultParams, {
                    filter: {
                        applied: [],
                        search: [],
                    },
                    sort: [lodash.get(config, 'sort.default', {})],
                });
                paramsSet = Object.assign({}, paramsSet, paramsSetObject);
            }

            function init() {
                $rootScope.$on([FilterFactory.eventPrefix, currentId, 'reload'].join('.'), function(e) {
                    lodash.get(configSet, [currentId, 'debouncedApplyFilter'].join('.'), function () {})(currentId);
                });
            }

            init();

            return {
                applyFilter: function(id, data) { lodash.get(configSet, [id, 'debouncedApplyFilter'].join('.'), function () {})(id, data) },
                setSort: setSort,
                getCount: getCount,
                eventPrefix: GROUP_FILTER_FACTORY,
                eventLoading: EVENT_LOADING,
                eventPageChange: EVENT_PAGE_CHANGE,
            };
        };
    }
})();